import React from "react";
import Wallpaper from "../../Shared/Wallpaper";
import { useDispatch, useSelector } from "react-redux";
import {
  setBgGradient,
  setBgWallpaper,
  setPatternColor,
  setSegmentBgColor,
  setSelectedColorType,
  setWallpaperOverlayColor,
  setWallpaperTransparency,
  setWallpaperHuePercentage,
  setWallpaperHueColor,
} from "../../../../redux/actions/wheelWallpaper";
import { pushToHistoryAction } from "../../../../redux/reducers/segmentBuilder";

export default function WallpaperTab() {
  const dispatch = useDispatch();
  const {
    wallpaperTransparency,
    wallpaperOverlayColor,
    bgWallpaper,
    isPattern,
    segmentBgColor,
    currentBg,
    selectedColorType,
    patternColor,
    wallpaperHuePercentage,
    wallpaperHueColor,
  } = useSelector((state) => state.wheelWallpaperReducer);

  return (
    <div style={{ height: "54vh", overflow: "auto" }}>
      <Wallpaper
        showAccordion={false}
        slider2Value={wallpaperTransparency}
        slider2Change={(value) => {
          dispatch(setWallpaperTransparency(value));
          dispatch(pushToHistoryAction());
        }}
        isShowTransparencySlider={false}
        slider2BoxTitle={"Opacity"}
        handleWallpaperOverlayColorChange={(value) => {
          dispatch(setWallpaperOverlayColor(value));
          dispatch(pushToHistoryAction());
        }}
        wallpaperOverlayColor={wallpaperOverlayColor}
        handleSelectWallpaper={(value) => {
          dispatch(setBgWallpaper(value, 0));
          dispatch(pushToHistoryAction());
        }}
        handleSelectPattern={(value) => {
          dispatch(setBgWallpaper(value, 1));
          dispatch(pushToHistoryAction());
        }}
        isPattern={isPattern}
        bgWallpaper={bgWallpaper}
        background={wallpaperOverlayColor}
        handlePatternColorChange={(value) => {
          dispatch(setPatternColor(value));
          dispatch(pushToHistoryAction());
        }}
        handleSelectColorType={(val) => {
          dispatch(setSelectedColorType(val));
          dispatch(pushToHistoryAction());
        }}
        selectedColorType={selectedColorType}
        patternColor={patternColor}
        onBgWallpaperColorChange={(value) => {
          dispatch(setSegmentBgColor(value));
          dispatch(pushToHistoryAction());
        }}
        currentBg={currentBg}
        segmentBgColor={segmentBgColor}
        handleGradientColor={(value) => {
          dispatch(setBgGradient(value));
          dispatch(pushToHistoryAction());
        }}
        showSuggestedColorPalette={false}
        showEmbedURLDisclaimer={true}
        huePercentage={wallpaperHuePercentage ?? 0}
        huePercentageChange={(value) => {
          dispatch(setWallpaperHuePercentage(value));
          dispatch(pushToHistoryAction());
        }}
        hueColor={wallpaperHueColor ?? "#ffffff"}
        hueColorChange={(value) => {
          dispatch(setWallpaperHueColor(value));
          dispatch(pushToHistoryAction());
        }}
      />
    </div>
  );
}
